export default __webpack_public_path__ + "static/media/Logo-white.4ae73e10.svg";